import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import CircularProgress from '@/components/CircularProgress/CircularProgress';

/**
 * Button component's props
 * @interface ButtonProps
 */
export interface ButtonProps extends MuiButtonProps {
  /**
   * Whether to show a loading state
   * @type {boolean}
   */
  loading?: boolean;
}

/**
 * Button component with styling matching AXP design
 * @param {ButtonProps} props
 */
const Button = (props: ButtonProps) => {
  const { children, variant, disabled = false, loading = false, ...rest } = props;

  return (
    <MuiButton
      disableElevation
      variant={variant}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && (
        <CircularProgress
          size={'20px'}
          sx={{ color: 'inherit', marginRight: loading ? '8px' : '0px' }}
        />
      )}
      {children}
    </MuiButton>
  );
};

export default Button;
